<template>
  <div class="global-message-container">
    <transition-group name="message" tag="div" class="message-list">
      <div
        v-for="message in messages"
        :key="message.id"
        :class="['message-item', `message-${message.type}`]"
      >
        <i :class="getIcon(message.type)"></i>
        <span class="message-text">{{ message.text }}</span>
        <i class="el-icon-close message-close" @click="removeMessage(message.id)"></i>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'GlobalMessage',
  computed: {
    ...mapState('app', ['messages'])
  },
  methods: {
    ...mapMutations('app', ['REMOVE_MESSAGE']),
    
    getIcon(type) {
      const iconMap = {
        success: 'el-icon-success',
        warning: 'el-icon-warning',
        error: 'el-icon-error',
        info: 'el-icon-info'
      }
      return iconMap[type] || 'el-icon-info'
    },
    
    removeMessage(id) {
      this.REMOVE_MESSAGE(id)
    }
  },
  
  mounted() {
    // 自动清除消息
    this.$store.watch(
      (state) => state.app.messages,
      (messages) => {
        if (messages && Array.isArray(messages)) {
          messages.forEach(message => {
            if (message.autoClose !== false) {
              setTimeout(() => {
                this.removeMessage(message.id)
              }, message.duration || 3000)
            }
          })
        }
      },
      { immediate: true, deep: true }
    )
  }
}
</script>

<style scoped lang="scss">
.global-message-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  width: 330px;
}

.message-list {
  .message-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    margin-bottom: 8px;
    border-radius: 6px;
    background: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-left: 4px solid #ddd;
    
    .message-text {
      flex: 1;
      margin-left: 8px;
      font-size: 14px;
    }
    
    .message-close {
      margin-left: 8px;
      cursor: pointer;
      color: #999;
      
      &:hover {
        color: #666;
      }
    }
    
    &.message-success {
      border-left-color: #67c23a;
      .el-icon-success {
        color: #67c23a;
      }
    }
    
    &.message-warning {
      border-left-color: #e6a23c;
      .el-icon-warning {
        color: #e6a23c;
      }
    }
    
    &.message-error {
      border-left-color: #f56c6c;
      .el-icon-error {
        color: #f56c6c;
      }
    }
    
    &.message-info {
      border-left-color: #409eff;
      .el-icon-info {
        color: #409eff;
      }
    }
  }
}

// 动画效果
.message-enter-active,
.message-leave-active {
  transition: all 0.3s ease;
}

.message-enter-from {
  opacity: 0;
  transform: translateX(100%);
}

.message-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
</style> 